import { html, rune, type Html, View } from 'rune-ts';
import klass from './CraftSection.module.scss';
import { getResizedUrl } from '../../../../../shared/util/image';
import { staticTypoPcMo } from '../../../../../shared/typography/typo';

interface CardProps {
  card_number: number;
  main_video_url: string;
  center_image_url: string;
  content_image_url?: string;
  content_video_url?: string;
}

export class CraftCardVideo extends View<CardProps> {
  override template({ main_video_url, center_image_url }: CardProps): Html {
    return html`
      <div class="${klass.craft_video_wrapper} craft_video_${this.data.card_number}">
        <video
          preload="none"
          autoplay=""
          loop=""
          muted=""
          playsinline=""
          class="${klass.craft_video}"
          src=${main_video_url}
        ></video>
        <img
          class="${klass.image}"
          src="${getResizedUrl({
            url: center_image_url,
            width: 1920 * 2,
            quality: 85,
            format: 'webp',
          })}"
          alt="MarppleShop handmade craft Image"
        />
      </div>
    `;
  }
}

export class CraftCardContent extends View<CardProps> {
  override template({ content_image_url, content_video_url, card_number }: CardProps) {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;
    const texts = {
      craft_title: html.preventEscape(ET(`mps2::landing::handmade::craft_title_${card_number}`)),
      craft_description: html.preventEscape(ET(`mps2::landing::handmade::craft_description_${card_number}`)),
    };

    return html`
      <div class="${klass.content_wrapper} craft_content_${this.data.card_number}">
        <div class="${klass.content}">
          <div
            class="${klass.craft_title} ${staticTypoPcMo({
              is_mobile,
              pc: 'bebas_48_bold',
              mo: 'bebas_28_bold',
            })}"
          >
            ${texts.craft_title}
          </div>
          ${content_image_url
            ? html`<div class="${klass.image_wrapper}">
                <img
                  src="${getResizedUrl({
                    url: content_image_url,
                    width: 1920 * 2,
                    quality: 85,
                    format: 'webp',
                  })}"
                  alt="MarppleShop handmade Craft Image"
                />
              </div>`
            : html`<div class="${klass.content_video_wrapper}">
                <video
                  preload="none"
                  autoplay=""
                  loop=""
                  muted=""
                  playsinline=""
                  src=${content_video_url}
                ></video>
              </div>`}
          <div
            class="${klass.craft_desc} ${staticTypoPcMo({
              is_mobile,
              pc: 'bebas_28_bold',
              mo: 'bebas_20_bold',
            })}"
          >
            ${texts.craft_description}
          </div>
        </div>
      </div>
    `;
  }
}

export class CraftCard extends View<CardProps> {
  craftCardVideo: CraftCardVideo;
  craftCardContent: CraftCardContent;

  constructor(data: CardProps) {
    super(data);
    this.craftCardVideo = new CraftCardVideo(data);
    this.craftCardContent = new CraftCardContent(data);
  }

  override template() {
    return html`
      <div class="${klass.card} craft_${this.data.card_number}">
        ${new CraftCardVideo(this.data)} ${new CraftCardContent(this.data)}
      </div>
    `;
  }
}
